/* Pantheratec Toolbox Hauptseite v1.0: filtering, searching and Theme Editor support */
(() => {
  'use strict';
  const fold = value => String(value || '').toLocaleLowerCase('de-DE')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\u00df/g, 'ss')
    .replace(/\s+/g, ' ').trim();

  function init(root) {
    if (root.dataset.pttbReady === 'true') return;
    root.dataset.pttbReady = 'true';
    const controls = root.querySelector('[data-pttb-controls]');
    const buttons = Array.from(root.querySelectorAll('[data-pttb-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-pttb-card]'));
    const input = root.querySelector('[data-pttb-search]');
    const empty = root.querySelector('[data-pttb-empty]');
    const reset = root.querySelector('[data-pttb-reset]');
    const count = root.querySelector('[data-pttb-count]');
    let category = 'all';

    function render() {
      const search = fold(input ? input.value : '');
      let shown = 0;
      cards.forEach(card => {
        const matches = (category === 'all' || card.dataset.category === category)
          && (!search || fold(card.dataset.search).includes(search));
        card.hidden = !matches;
        if (matches) shown += 1;
      });
      buttons.forEach(button => {
        const active = button.dataset.pttbFilter === category;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (empty) empty.hidden = shown !== 0;
      if (count) count.textContent = shown + ' von ' + cards.length + ' Tools angezeigt';
    }
    function clear() {
      category = 'all';
      if (input) input.value = '';
      render();
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      category = button.dataset.pttbFilter;
      render();
    }));
    if (input) input.addEventListener('input', render);
    if (reset) reset.addEventListener('click', () => {
      clear();
      if (input) input.focus();
    });
    if (controls) controls.hidden = cards.length === 0;
    render();
    root.pttbRevealCard = card => {
      if (!cards.includes(card)) return;
      clear();
      card.scrollIntoView({behavior: 'smooth', block: 'center'});
    };
  }

  function initAll(scope) {
    if (scope.matches && scope.matches('[data-pttb]')) init(scope);
    scope.querySelectorAll('[data-pttb]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), {once: true});
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('[data-pttb-card]');
    if (!card) return;
    const root = card.closest('[data-pttb]');
    if (root && typeof root.pttbRevealCard === 'function') root.pttbRevealCard(card);
  });
})();
